import { Grid } from 'common';
import isArray from 'lodash/isArray';
import React, { Component } from 'react';

const { GridPanel } = Grid;

class TransactionConfirmationContent extends Component {
	constructor(props) {
		super(props);

		const { locationRows, responseData } = props;
		const allocatedFundItems = isArray(responseData.AllocatedFundItems)
			? responseData.AllocatedFundItems
			: [];

		this.state = {
			allocatedFundType: responseData.AllocatedFundType,

			columnDefs: [
				{
					headerName: 'Location Name',
					field: 'location',
					filter: true,
					flex: 1,
					sortable: true,
				},
				{
					headerName: 'Fund Amount',
					field: 'fundAmount',
					filter: false,
					maxWidth: 200,
					sortable: false,
				},
			],

			rowData: allocatedFundItems.map(({ Amount = 0, CustId }) => {
				const locationName = isArray(locationRows)
					? locationRows.find(location => location.custId === CustId)
					: {};

				return {
					location: locationName ? locationName.location : '',
					fundAmount: `$${Amount.toFixed(2)}`,
				};
			}),
		};
	}

	onGridReady = ({ api }) => {
		this.gridApi = api;
	};

	// update column state when user sorts the column
	onSortChanged = sortModel => {
		this.gridApi.setSortModel(sortModel);
	};

	render() {
		const { responseData } = this.props;
		const { allocatedFundType, columnDefs, rowData } = this.state;

		return (
			<div className="transaction-confirmation-content">
				{/* Check */}
				{allocatedFundType === 1 && (
					<>
						<p className="body-text">
							<strong>
								In order to finalize your transaction, please complete the
								following steps:
							</strong>
						</p>
						<ol>
							<li>
								<p>
									<strong>Write</strong> a check payable to Stamps.com and
									include the reference number on the check.
								</p>
								<div className="display-info">
									<div className="display-label">Total Fund Amount:</div>
									<div className="display-data">
										${responseData.TotalAmount.toFixed(2)}
									</div>
								</div>
								<div className="display-info">
									<div className="display-label">Reference Number:</div>
									<div className="display-data">
										{responseData.ReferenceNumber}
									</div>
								</div>
							</li>
							<li>
								<strong>Print</strong> this page and include it with your check.
							</li>
							<li>
								<p>
									<strong>Mail</strong> the check and printed page to the
									following address:
								</p>
								<div className="display-info align-top">
									<div className="display-label">Mailing Address:</div>
									<div className="display-data">
										{responseData.MailingCompanyName}
										<br />
										{responseData.MailingAddress1}
										<br />
										{responseData.MailingCity}, {responseData.MailingState}{' '}
										{responseData.MailingZip}
									</div>
								</div>
							</li>
						</ol>
						<p>
							If you have any questions or concerns regarding this transaction,
							please contact your Enterprise Account Representative at
							877-782-6785.
						</p>
						<GridPanel
							rowData={rowData}
							columnDefs={columnDefs}
							showPagination={false}
							domLayout="autoHeight"
							onGridReady={this.onGridReady}
							onSortChanged={this.onSortChanged}
						/>
						<p>
							We will deposit the funds into each of your locations within 1-3
							business days of receiving your check.
						</p>
					</>
				)}
				{/* ACH Credit */}
				{allocatedFundType === 2 && (
					<>
						<p className="body-text">
							<strong>
								To finalize the ACH Credit transfer, please contact your bank
								and provide them with the following information:
							</strong>
						</p>
						<div className="p-grid">
							<p className="p-col-12 p-lg-4 p-md-4">
								<strong>USPS Bank Information</strong>
								<br />
								Routing Number: {responseData.RoutingNumber}
								<br />
								Account Number: {responseData.AccountNumber}
							</p>
							<p className="p-col-12 p-lg-8 p-md-8">
								<strong>Transaction Details</strong>
								<br />
								Reference Number: {responseData.ReferenceNumber}
								<br />
								Total Fund Amount: ${responseData.TotalAmount.toFixed(2)}
							</p>
						</div>
						<p>
							<strong>Important:</strong> You must provide your bank with the
							reference number in order to complete the transaction. Stamps.com
							will match this reference number with the amount of funds
							requested for each location to complete the transaction. Failure
							to provide the reference number will significantly delay the
							funding of your locations. Please print this page for your
							records.
						</p>
						<p>
							If you have any questions or concerns regarding this transaction,
							please contact your Enterprise Account Representative at
							877-782-6785.
						</p>
						<GridPanel
							rowData={rowData}
							columnDefs={columnDefs}
							showPagination={false}
							domLayout="autoHeight"
							onGridReady={this.onGridReady}
							onSortChanged={this.onSortChanged}
						/>
						<p>
							We will deposit the funds into each of your locations within 1-3
							business days of receiving confirmation that the following
							transaction is complete.
						</p>
					</>
				)}
				{/* Overdraft */}
				{allocatedFundType === 3 && (
					<>
						<p className="body-text">
							We will deposit the funds into each of your locations within 1-3
							business days and will mail an invoice for the total amount owed
							to the billing contact on your account.
						</p>
						<div className="p-grid">
							<p className="p-col-12 p-lg-8 p-md-8">
								<strong>Transaction Details</strong>
								<br />
								{`Reference Number:  ${responseData.ReferenceNumber}`}
								<br />
								{`Total Fund Amount:  ${responseData.TotalAmount.toFixed(2)}`}
							</p>
						</div>
						<GridPanel
							rowData={rowData}
							columnDefs={columnDefs}
							showPagination={false}
							domLayout="autoHeight"
							onGridReady={this.onGridReady}
							onSortChanged={this.onSortChanged}
						/>
						<p>Please print this page for your records.</p>
						<p>
							If you have any questions or concerns regarding this transaction,
							please contact your Enterprise Account Representative at
							877-782-6785.
						</p>
					</>
				)}
			</div>
		);
	}
}

export default TransactionConfirmationContent;
